export const compareStrategies = (state) => {
  return state.strategies.strategies.filter(strategy => state.strategies.compareStrategyIds.includes(strategy.id))
}

export const getEffectsBySelectedWeeds = (state, selected) => {
  return state.strategies.compareStrategiesData.effects.filter(effect =>  effect[0].selected === selected)
}

export const selectedTreatmentGroup = (state) => {
  return state.strategies.treatmentGroups?.find(treatmentGroup => treatmentGroup.value === state.strategies.treatmentGroups.selectedTreatmentGroupValue) || null
}